// Does not exist in web
export const NotificationPermission = () => null;
